import React, { useEffect, useState } from 'react'
import { Heading, Text } from '../../components/styledConstants'
import { AddManageAdminWrapper } from '../MerchantDetail/style'
import { AddAdminWrapper } from '../../components/ManageAdmin/style'
import MaterialInput from '../../components/common/UI/MaterialInput'
import { useSelector } from 'react-redux'
import { isEmpty } from '../../utils/common'
import { useParams } from 'react-router-dom'
import config from '../../utils/config'
import Request from "../../utils/Request";

function UserProfile() {

    const { user } = useSelector((state) => state.user);


    const [virtualAccount, setVirtualAccount] = useState([]);
    const id = user.userUuid
    console.log("id",user.userUuid)
    useEffect(() => {  
      if (id) {
        fetchUserVirtualAccount(id);    
      }
    }, [id]);
    
    const fetchUserVirtualAccount = (id) => {
      const successHandler = (res) => {
        if (res && res?.data && res?.data?.details) {
          setVirtualAccount(res?.data?.details);
        }
      };
      const errorHandler = (err) => {
        console.error('Error fetching virtual account:', err);
      };
      const api = new Request("", successHandler, errorHandler, false);
  
      return api.get(`${config.apis.admin.USER_VIRTUAL_ACCOUNT}/${id}`);
    }; 

  return (
    <div className=" space-between">
    <Heading size="xxxl">Profile</Heading>

    <div className="mt24">
          <AddManageAdminWrapper>
   
      <div className="form-wrapper mt32">
        <AddAdminWrapper>
        
            <form className="mt20" onSubmit={(e) => e.preventDefault()}>
             
              <div className="flex flex-center gap28 mb20">
                <MaterialInput
                  name="firstName"
                  value={user?.firstName}
                  className="item-text"
                  type="text"
                  placeholder="First name"
                  readOnly={true}
                />
                <MaterialInput
                  name="lastName"
                  value={user?.lastName}
                  className="item-text"
                  type="text"
                  placeholder="Last Name"
                  readOnly={true}
                />
              </div>
              <div className="flex flex-center gap28 mb20">
                <MaterialInput
                  name="user Role"
                  value={user?.userType}
                  className="item-text"
                  type="text"
                  placeholder="Role"
                />
                <MaterialInput
                  name="mobileNumber"
                  value={user?.mobile}
                  className="item-text"
                  type="text"
                  placeholder="Mobile No."
                />
              </div>
              <div className="flex flex-center gap28 mb20">
                <MaterialInput
                  name="emailId"
                  value={user?.email}
                  type="text"
                  placeholder="Email Id"
                />
                <MaterialInput
                  name="dob"
                  value={user?.dob}
                  dateFormat="MMM dd yyyy"
                  showMonthDropdown
                  showYearDropdown
                  yearDropdownItemNumber={80}
                  scrollableYearDropdown
                  placeholder="D.O.B."
                
                />
              </div>
            
             
             
          {!isEmpty(user?.address) &&  <>
              <div className="flex flex-center gap28 mb20">
                <MaterialInput
                  type="State"
                  name="state"
                  value={user?.address?.state}
                  placeholder="State"
                />
                <MaterialInput
                  name="City"
                  value={ user?.address?.city}
                  type="text"
                  placeholder="City"
                />
              </div>
              <div className="flex flex-center gap28 mb20">
                <MaterialInput
                  type="Address Type"
                  name="address"
                  value={user?.tenantType}
                  placeholder="Address Type"
                />
                 <MaterialInput
                  name="Pincode"
                  value={user?.address?.pinCode}
                  type="text"
                  placeholder="Pincode"
                />
          
              </div>
              </>
             }
            </form>
          

        

         
        </AddAdminWrapper>
     
     {user?.userType === "ROLE_MERCHANT_DISTRIBUTOR"  ?  <AddAdminWrapper>
          <Text size ="rg" color='color15'> Virtual Account Details:</Text>

          <div className="flex flex-center gap28 mb20 mt20">
                <MaterialInput
                  name="accountNumber"
                  value={virtualAccount?.accountNumber}
                  className="item-text"
                  type="text"
                  placeholder="Account Number"
                  readOnly={true}
                />
                <MaterialInput
                  name="accountHolderName"
                  value={virtualAccount?.shortName}
                  className="item-text"
                  type="text"
                  placeholder="Account Holder Name"
                  readOnly={true}
                />
              </div>
              <div className="flex flex-center gap28 mb20" style={{width:"49%"}}>
                <MaterialInput
                  name="ifscCode"
                  value={virtualAccount?.ifsCode}
                  className="item-text"
                  type="text"
                  placeholder="Ifsc Code"
                />
               
              </div>
             
          </AddAdminWrapper>
     
     :""}
     
     
      </div>



          </AddManageAdminWrapper>
          
       
          
          
          </div>
    </div>
  )
}

export default UserProfile